/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { St } from './St';

class BuyerSaleStat extends St {
    constructor() {
        super();
        this.baseUrl += '/buyerSaleStat';
    }

    data({ type, statDateTime, statDateDay, statDateWeek, statDateMonth, currentPage, pageSize } = {}) {
        let statDateTimeBegin = null;
        let statDateTimeEnd = null;
        if (statDateTime != null && statDateTime.length === 2) {
            [statDateTimeBegin, statDateTimeEnd] = statDateTime;
        }
        let statDateDayBegin = null;
        let statDateDayEnd = null;
        if (statDateDay != null && statDateDay.length === 2) {
            [statDateDayBegin, statDateDayEnd] = statDateDay;
        }
        let statDateMonthBegin = null;
        let statDateMonthEnd = null;
        if (statDateMonth != null && statDateMonth.length === 2) {
            [statDateMonthBegin, statDateMonthEnd] = statDateMonth;
        }
        return super.get('/data', {
            type,
            statDateTimeBegin,
            statDateTimeEnd,
            statDateDayBegin,
            statDateDayEnd,
            statDateMonthBegin,
            statDateMonthEnd,
            statDateWeek,
            currentPage,
            pageSize,
        });
    }
}

export default new BuyerSaleStat();
export { BuyerSaleStat };
